import React from 'react';

/**
 * Lightweight shimmer skeleton shown while a table/panel is loading.
 * Props: { rows }
 */
const TableSkeleton = ({ rows = 6 }) => (
  <div className="au-skeleton" data-testid="au-skeleton" aria-busy="true" aria-live="polite">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="au-skeleton__row" />
    ))}
  </div>
);

export default TableSkeleton;
